<div class="row">
  @if (termin.angebot.bildungsanbieter; as anbieter) {
    <div class="col-12 col-lg-6">
      <now-wbsuche-lib-detail-kachel
        [id]="'anbieter'"
        [title]="'Bildungsanbieter'"
        [icon]="'now-icon-buildings'"
        [collapseButtonText]="'zu dem Bildungsanbieter'"
        (collapsedChanged)="collapseStates.bildungsanbieter = $event"
      >
        <now-wbsuche-lib-bildungsanbieter
          [anbieter]="anbieter"
          [collapsed]="collapseStates.bildungsanbieter"
        ></now-wbsuche-lib-bildungsanbieter
      ></now-wbsuche-lib-detail-kachel>
    </div>
  }

  <div class="col-12" [class.col-lg-6]="termin.angebot.bildungsanbieter">
    <now-wbsuche-lib-detail-kachel
      [id]="'kontakt-personen'"
      [title]="termin.ansprechpartner.length === 1 ? 'Kontaktperson' : 'Kontaktpersonen'"
      [icon]="'now-icon-address-book'"
      [collapseButtonText]="
        'zu ' +
        (termin.ansprechpartner.length
          | i18nPlural: { '=1': 'der Kontaktperson', other: 'den Kontaktpersonen' })
      "
      (collapsedChanged)="collapseStates.kontaktperson = $event"
    >
      <div>
        @if (termin.ansprechpartner.length > 1) {
          <section
            #carouselElement
            id="carousel-kontaktpersonen"
            class="now-carousel pb-1"
            aria-roledescription="carousel"
            aria-label="Slider mit den Kontaktpersonen"
          >
            <div class="now-carousel-slides-container">
              <div class="now-carousel-slides">
                @for (person of termin.ansprechpartner; track person.id) {
                  <div class="now-carousel-slide" role="group" aria-roledescription="slide">
                    <now-wbsuche-lib-kontakt-slider-kachel
                      [person]="person"
                      [collapsed]="collapseStates.kontaktperson"
                    ></now-wbsuche-lib-kontakt-slider-kachel>
                  </div>
                }
              </div>
            </div>
            <div class="now-carousel-controls">
              <!-- prettier-ignore -->
              <button type="button" class="now-btn now-btn-secondary now-btn-icon-only now-icon-caret-left"
                    aria-label="vorherige Kontaktperson" title="vorherige Kontaktperson"></button>
              <div class="now-carousel-label" role="status"></div>
              <!-- prettier-ignore -->
              <button type="button" class="now-btn now-btn-secondary now-btn-icon-only now-icon-caret-right"
                    aria-label="nächste Kontaktperson" title="nächste Kontaktperson"></button>
            </div>
          </section>
        }

        <div>
          @if (termin.ansprechpartner.length === 1) {
            <now-wbsuche-lib-kontakt-slider-kachel
              [person]="termin.ansprechpartner[0]"
              [collapsed]="collapseStates.kontaktperson"
            ></now-wbsuche-lib-kontakt-slider-kachel>
          }
        </div>

        @if (termin.ansprechpartner.length === 0) {
          <p id="keine-kontaktpersonen-hinweise">
            Aktuell sind keine Informationen zu einzelnen Kontaktpersonen bekannt. <br />
            Bei Fragen zur Veranstaltung bitte direkt an den Bildungsanbieter wenden.
          </p>
        }
      </div>
    </now-wbsuche-lib-detail-kachel>
  </div>
</div>
